import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DetailedTicketSource } from '@sb-tools/typescript/enums/detailed-ticket-source.enum';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { TicketStatus } from '@sb-tools/typescript/enums/ticket-status.enum';
import { TicketListItemDTO } from '@sb-tools/typescript/models/dto/ticket-list-item.dto';
import { Importance } from '@sb-tools/typescript/enums/importance.enum';
import { InlineSVGComponent } from '../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DatePipe, NgClass } from '@angular/common';
import { UserAvatarComponent } from '../../../sb-modules/Frontend-User-Avatar-Module/user-avatar.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaceEmojisPipe } from '../../../sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';
import { TicketTimePipe } from '../../../sb-tools/typescript/pipes/ticket/ticket-time.pipe';
import { DetailedTicketSourcePipe } from '../../shared/pipes/detailed-ticket-source.pipe';
import { TicketSourceEnglishPipe } from '../../shared/pipes/ticket-source-english.pipe';
import { CategoryFullNamePipe } from '../../shared/pipes/category-full-name.pipe';

@Component({
    selector: 'app-ticket-list-item',
    templateUrl: './ticket-list-item.component.html',
    styleUrls: ['./ticket-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        InlineSVGComponent,
        TooltipModule,
        NgClass,
        UserAvatarComponent,
        DatePipe,
        TranslateModule,
        ReplaceEmojisPipe,
        TicketTimePipe,
        DetailedTicketSourcePipe,
        TicketSourceEnglishPipe,
        CategoryFullNamePipe,
    ],
})
export class TicketListItemComponent implements OnInit {
    @Input() changeDetectionMarker: number;
    @Input() isFeedViewMinimized: boolean;
    @Input() ticket: TicketListItemDTO;

    detailedTicketSourceEnum = DetailedTicketSource;
    importanceEnum = Importance;
    isStatusAvailable: boolean;
    ticketStatusEnum = TicketStatus;

    constructor(public commonDataService: CommonDataService) {}

    ngOnInit() {
        this.isStatusAvailable = ['seleniumtests', 'vikingline', 'carglass'].includes(this.commonDataService.community);
    }
}
